"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountBar = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const CountBarStyles_1 = require("../../style/CountBarStyles");
class CountBar extends react_1.default.Component {
    getWidth() {
        if (this.props.maxValue && this.props.currentValue) {
            return `${100 * (this.props.currentValue / this.props.maxValue)}%`;
        }
        return 0;
    }
    render() {
        const barSizeStyle = {
            maxWidth: this.props.maxWidth,
            width: this.props.maxWidth,
            height: this.props.height,
            minWidth: this.props.currentValue && this.props.currentValue > 0 ? 2 : 0,
        };
        return (react_1.default.createElement("div", { className: this.props.colorPaletteName && CountBarStyles_1.colorPalettes[this.props.colorPaletteName], style: { borderRadius: 'inherit' } },
            react_1.default.createElement("div", { className: this.props.shouldAnimateBarWidth ? CountBarStyles_1.animatedBaseBarClass : CountBarStyles_1.baseBarClass, style: barSizeStyle },
                react_1.default.createElement("div", { className: this.props.shouldAnimateBarWidth ? CountBarStyles_1.animatedFilteredBarClass : CountBarStyles_1.filteredBarClass, style: Object.assign(Object.assign({}, barSizeStyle), { width: this.getWidth() }) }),
                this.props.label
                    ? react_1.default.createElement(CountBarStyles_1.BarLabel, { style: { lineHeight: `${this.props.height + 2}px` } }, this.props.label)
                    : null)));
    }
}
exports.CountBar = CountBar;
//# sourceMappingURL=CountBar.js.map